import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { open as openRegistration } from '@central-products/registration-integration-kit';
import { WHO_REGISTER_SUCCESS } from '../../../routes/paths';
import { getLinkAccountPage, getRegisterPage } from '../../../modules/content/selectors';
import { open, close as closeModal } from '../../../modules/modal/actions';
import { openOnlineLinkModal } from '../../../modules/analytics/actions';
import linkAccountBackupContent from '../../../../resources/linkAccountBackup.json';
import registerBackupContent from '../../../../resources/registerBackup.json';

const CONTENT_LOGIN = 'login';

export class LinkAccountTerms extends Component {
  constructor() {
    super();
    this.showLogin = this.showLogin.bind(this);
    this.showRegistration = this.showRegistration.bind(this);
  }

  showLogin() {
    const { analyticsAction, openLoginModal, close } = this.props;
    close();
    analyticsAction('Login');
    openLoginModal();
  }

  showRegistration() {
    const { analyticsAction, close } = this.props;
    close();
    analyticsAction('Registration');
    const backUrl = `${window.location.protocol}//${window.location.host}${WHO_REGISTER_SUCCESS}`;
    openRegistration({
      baseUrl: `${api_config.online_auth_url}/rsp/`,
      regSource: 'OW',
      locale: 'en-gb',
      nui: 'plus40',
      successRedirectUrl: encodeURIComponent(backUrl)
    });
  }

  render() {
    const { registerPageContent, linkAccountPageContent, close, contentToDisplay } = this.props;
    let linkAccountContent;
    if (linkAccountPageContent) {
      linkAccountContent = linkAccountPageContent;
    } else {
      linkAccountContent = linkAccountBackupContent;
    }
    let registerContent;
    if (registerPageContent) {
      registerContent = registerPageContent;
    } else {
      registerContent = registerBackupContent;
    }
    const clickNext = contentToDisplay === CONTENT_LOGIN ? this.showLogin : this.showRegistration;
    const terms = contentToDisplay === CONTENT_LOGIN ? linkAccountContent.terms : registerContent.terms;

    return (
      <div className="modal" data-test-id="link-account-terms">
        <div className="modal__top-nav">
          <div className="modal__top-nav-item" onClick={close}>
            <i className="icon icon--arrow-left" />
            Back
          </div>
          <div className="modal__top-nav-item" onClick={clickNext} data-test-id="link-account-terms-next">
            Next
            <i className="icon icon--arrow-right" />
          </div>
        </div>
        <div className="modal__content-scrollable">
          {!!terms.heading && (<h2 className="terms-page__subtitle">{terms.heading}</h2>)}
          <div className="cms-content cms-content--white-background" dangerouslySetInnerHTML={{ __html: terms.text }} />
        </div>
      </div>
    );
  }
}

LinkAccountTerms.propTypes = {
  analyticsAction: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  contentToDisplay: PropTypes.string.isRequired,
  linkAccountPageContent: PropTypes.object,
  openLoginModal: PropTypes.func.isRequired,
  registerPageContent: PropTypes.object,
};

const mapStateToProps = state => ({
  linkAccountPageContent: getLinkAccountPage(state),
  registerPageContent: getRegisterPage(state),
});

const mapDispatchToProps = {
  close: closeModal,
  openLoginModal: open.bind(null, {
    componentName: 'OnlineLogin',
    componentProps: { requestSource: 'login' }
  }),
  analyticsAction: openOnlineLinkModal
};

export default connect(mapStateToProps, mapDispatchToProps)(LinkAccountTerms);
